import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/verify-saint-provider")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-tms-locations" },
      replace: true,
    });
  },
});
